// The host and display mode a person saved (People.user.avatarName / avatarType),
// applied when they sign in on the website (REACT_APP_LOGIN_AVATAR_TYPE_ENABLED,
// default on). The database holds the type as "3D", "3d", "2D" or "2d".

// "Maggie" kept only as legacy alias — older Mongo records may still store avatarName "Maggie"
export const AVATAR_NAME_MAP = { "Benjamin":"Benjamin","Benji":"Benjamin","Camille":"Camille","camille":"Camille","Prithi":"Prithi","prithi":"Prithi","John":"John","john":"John","Margie":"Margie","margie":"Margie","Maggie":"Margie","maggie":"Margie","Genie":"Genie","genie":"Genie" };
export const WEB_AVATARS = ["Camille","Prithi","Benjamin","John","Margie","Genie"];

export const LOGIN_AVATAR_TYPE_ENABLED = process.env.REACT_APP_LOGIN_AVATAR_TYPE_ENABLED !== "false";

// "2D" | "3D", or null when nothing usable is saved.
export function normalizeAvatarType(value) {
  const v = String(value || "").trim().toUpperCase();
  return v === "2D" || v === "3D" ? v : null;
}

// The saved host mapped to a website avatar (or the raw name when the website has
// no such avatar), and the saved display mode.
export function savedAvatarPrefs(user) {
  const name = AVATAR_NAME_MAP[user?.avatarName] || user?.avatarName || "Camille";
  return { avatarName: name, isWebAvatar: WEB_AVATARS.includes(name), avatarType: normalizeAvatarType(user?.avatarType) };
}

// Resolves once the host of this mode can speak (or after the wait, when the
// fallback voice takes over): 2D draws its speaker on mount, 3D its voice engine.
export function waitForHostVoice(type, win = window, { timeoutMs = 5000, stepMs = 100 } = {}) {
  const ready = () => (type === "2D" ? !!win.camille2DSpeak : !!win.currentAvatarTTS);
  return new Promise((resolve) => {
    const started = Date.now();
    const check = () => {
      if (ready() || Date.now() - started >= timeoutMs) return resolve(ready());
      setTimeout(check, stepMs);
    };
    check();
  });
}
